import { render, staticRenderFns } from "./displayModule.vue?vue&type=template&id=768c74e2&scoped=true"
import script from "./displayModule.vue?vue&type=script&lang=js"
export * from "./displayModule.vue?vue&type=script&lang=js"
import style0 from "./displayModule.vue?vue&type=style&index=0&id=768c74e2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768c74e2",
  null
  
)

export default component.exports